import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProductStockItem } from '../../../../../core/api/api.entities';
import { DashboardService } from '../../../../../core/services/dashboard.service';
import { IdleService } from '../../../../../core/services/idle.service';
import { DashboardProductForm } from '../../../../../forms/forms/dashboard-product.form';
import { QuickActionForm } from '../../../../../forms/forms/quick-action.form';
import { ProductActionType } from '../../../../../shared/enums/product-action-type.enum';
import { QuickActionForms } from '../../../../../shared/models/dashboard-forms.model';
import { DashboardActionDialogComponent } from '../dashboard-action-dialog/dashboard-action-dialog.component';

@Component({
  selector: 'app-dashboard-quick-action-dialog',
  templateUrl: './dashboard-quick-action-dialog.component.html',
  styleUrl: './dashboard-quick-action-dialog.component.scss',
})
export class DashboardQuickActionDialogComponent extends DashboardActionDialogComponent implements OnInit {
  productActionTypes = Object.values(ProductActionType).filter(value => value !== ProductActionType.Purchase);
  showErrors = false;

  constructor(
    service: DashboardService,
    private dialog: MatDialog,
    private idleService: IdleService
  ) {
    super(service);
  }

  ngOnInit(): void {
    this.quickActionForms.consume.controls.date.setValue(new Date());
    this.quickActionForms.open.controls.date.setValue(new Date());
    this.forms.product = new DashboardProductForm();
    this.service.product = undefined;

    if (this.productActionType === ProductActionType.Purchase) {
      this.setProductActionType(ProductActionType.Consume);
    }
    this.idleService.idle$.subscribe(_s => {
      this.dialog.closeAll();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get form(): QuickActionForm<any> {
    switch (this.productActionType) {
      case ProductActionType.Consume:
        return this.quickActionForms.consume;
      case ProductActionType.Transfer:
        return this.quickActionForms.transfer;
      default:
        return this.quickActionForms.open;
    }
  }

  get isConsume(): boolean {
    return this.productActionType === ProductActionType.Consume;
  }

  get isLoading(): boolean {
    return this.service.state.isLoading;
  }

  get isSubmitting(): boolean {
    return this.service.state.isSubmitting;
  }

  get isTransfer(): boolean {
    return this.productActionType === ProductActionType.Transfer;
  }

  get quickActionForms(): QuickActionForms {
    return this.forms.quickAction;
  }

  get stockItems(): ProductStockItem[] {
    return this.service.product?.activeStockItems || [];
  }

  submit(): void {
    this.service.submitQuickAction(this.form.productAction).subscribe();
  }

  getStockEntryDisplayValue(stockItem: ProductStockItem): string {
    let stockEntryDisplayValue = `${stockItem.amount}`;

    if (stockItem.amount === 1) {
      stockEntryDisplayValue += ` ${this.form.quantityUnit?.name}`;
    } else {
      stockEntryDisplayValue += ` ${this.form.quantityUnit?.namePlural}`;
    }

    if (stockItem.openedAt) {
      stockEntryDisplayValue += ' (opened) ';
    }

    stockEntryDisplayValue += ` · ${stockItem.locationName}`;

    return stockEntryDisplayValue;
  }
}
